import React, { useEffect, useState } from "react";
import apiCalls from "../PowerShadesAPIFunctions";
import { isFailedApiCall } from "../psUtil";
import { EntityListFullResp } from "../powershadesApiTypes";
import PowerShadesTypeahead from "./PowerShadesTypeahead";
import { fakeRootType } from "../FakeRootType";

type EntitySelectFullProps = {
    placeholder?: string;
    disabled?: boolean;
    onSubmit: (entityId: number, entityType: string) => void;
    ROOT: fakeRootType;
    disableAutoSubmit?: boolean;
    hideSubmitButton?: boolean;
    showAll?: boolean;
};

const EntitySelectFull = (props: EntitySelectFullProps) => {

    const { onSubmit, ROOT, disableAutoSubmit = false, hideSubmitButton = false, showAll = false } = props;

    const { setTitle, loaded, alert } = ROOT;


    // const roleOption: {
    //     value: string;
    //     label: string;
    // }[] = [
    //         { value: "dealer", label: "Dealer" },
    //         { value: "distributor", label: "Distributor" },
    //         { value: "representative", label: "Representative" }
    //     ];

    const [entityType, setEntityType] = useState("");
    const [entityList, setEntityList] = useState<EntityListFullResp>();
    const [selectedEntityName, setSelectedEntityName] = useState("");


    const { dealers = [], distributors = [], representatives = [] } = entityList ?? {};
    const totalEntities = (dealers?.length ?? 0) + (distributors?.length ?? 0 )+ (representatives?.length ?? 0);

    useEffect(() => {
        apiCalls
            .getAccessableEntities()
            .then((resp) => {
                if (isFailedApiCall(resp)) throw resp;

                const entities = resp.data.entities;

                const { dealers = [], distributors = [], representatives = [] } = entities;

                const totalAmount = (dealers?.length ?? 0) + (distributors?.length ?? 0) + (representatives?.length ?? 0);

                if (totalAmount === 1) {
                    // Redirect
                    let workingEntityType = "";
                    let id = 0;

                    if ((dealers?.length ?? 0) > 0) {
                        workingEntityType = "dealers";
                        id = dealers[0]?.id ?? 0;
                    } else if ((distributors?.length ?? 0) > 0) {
                        workingEntityType = "distributors";
                        id = distributors[0]?.id ?? 0;
                    } else if ((representatives?.length ?? 0) > 0) {
                        workingEntityType = "representatives";
                        id = representatives[0]?.id ?? 0;
                    }
                    
                    let entityName = "";
                    if (workingEntityType === "dealers") {
                        entityName = dealers[0]?.name ?? "";
                    } else if (workingEntityType === "distributors") {
                        entityName = distributors[0]?.name ?? "";
                    } else if (workingEntityType === "representatives") {
                        entityName = representatives[0]?.name ?? "";
                    }

                    setEntityType(workingEntityType);
                    setSelectedEntityName(entityName);

                    !disableAutoSubmit && onSubmit(id, workingEntityType);
                } else {
                    loaded();
                }
                setEntityList(entities);
            })
            .catch((resp) => {
                console.error({ resp });
                const error = resp?.error
                    ?? `Something went wrong loading your payment methods.
					Please reach out to PowerShades customer service.`;
                alert({
                    quickFormat: "error",
                    text: error,
                });
                throw new Error("Something went wrong loading entities");
            });
    }, [loaded, setTitle, alert]);

    const selectedEntitiesFromType = entityList ? entityList[entityType] ?? [] : [];
    const selectedEntity = selectedEntitiesFromType.find(e => e.name === selectedEntityName);

    console.log({ selectedEntity, selectedEntitiesFromType })

    const currentEntityListOptions = selectedEntitiesFromType.map(e => ({ label: e.name, value: e.name }));

    const currentEntityOption = currentEntityListOptions.find(e => e.value === selectedEntityName);
    const selectedOptionList = currentEntityOption ? [currentEntityOption] : [];

    useEffect(() => {
        if (!disableAutoSubmit) {
            if (selectedEntity) {
                onSubmit(selectedEntity.id, entityType);
            } else {
                onSubmit(0, entityType);
            }
        }
    }, [entityType, selectedEntityName, disableAutoSubmit, selectedEntity]);

    const isDisabled = totalEntities === 1;

    return (
        <>
            {!isDisabled && <div className={"mb-4"}>
                <h3>Entity Type</h3>
                <select
                    className={"form-select"}
                    value={entityType}
                    // placeholder="Please Select"
                    onChange={(e) => setEntityType(e.target.value)}

                >
                    <option value="">{showAll ? "All Entities" : "Select..."}</option>
                    <option value="dealers">Dealers</option>
                    <option value="distributors">Distributors</option>
                    <option value="representatives">Representatives</option>
                </select>
            </div>}
           { entityType !== "" && <div>
                <h3>Entity Name</h3>
                <PowerShadesTypeahead
                    id="entity-emails-listing"
                    options={currentEntityListOptions}
                    className="buying-groups-selector"
                    labelKey={"label"}
                    placeholder={"Please Select"}
                    selected={selectedOptionList}
                    disabled={isDisabled}
                    onChange={(e) => {

                        const item = e[0] ?? "";

                        const name = typeof item == "string" ? item : item.value

                        console.log(e);
                        setSelectedEntityName(name);

                        if (!disableAutoSubmit) {
                            if (selectedEntity) {
                                onSubmit(selectedEntity.id, entityType);
                            }
                        }
                        // e !== null ? setSelectedEntityName(e) : setEntitySelected("");
                    }}
                />
            </div>}
            {!hideSubmitButton && <div>
                <button
                    disabled={isDisabled}
                    onClick={() => {
                        if (selectedEntity) {
                            onSubmit(selectedEntity.id, entityType);
                        }
                    }}
                >
                    Submit
                </button>
            </div>}

        </>
    )

}

export default EntitySelectFull;